import React from 'react';

const getOrganizationJsonLd = (artist) => {
  return {
    '@type': 'Organization',
    name: artist.name,
    url: artist.url,
  };
};

const getOffersJsonLd = (product, currency = 'GBP') => {
  const result = {
    '@type': 'Offer',
    price: product?.pricing?.[currency]?.['current_amount']?.toFixed(2)?.toString(),
    priceCurrency: currency,
    availability: product?.quantity > 0 ? 'InStock' : 'OutOfStock',
    itemCondition: 'https://schema.org/NewCondition',
    url: product.full_url,
  };

  if (product?.sale_ends_datetime) {
    result['priceValidUntil'] = product?.sale_ends_datetime;
  }

  return result;
};

const getAggregateRatingJsonLd = (artist) => {
  return {
    '@type': 'AggregateRating',
    ratingCount: artist.review_data.review_count,
    ratingValue: artist.review_data.seller_rating,
    itemReviewed: {
      '@context': 'https://schema.org/',
      '@type': 'Organization',
      name: artist.name,
    },
  };
};

export const getPaintingJsonLd = (product, artist, currency = 'GBP') => {
  if (!currency) {
    currency = 'GBP';
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'Painting',
    creator: artist.name,
    name: product.name,
    isFamilyFriendly: product.verified_advertising_safe ? 'True' : 'False',
    genre: product.style_name,

    provider: getOrganizationJsonLd(artist),

    offers: getOffersJsonLd(product, currency),

    ...(product.review_count > 0 && {
      aggregateRating: getAggregateRatingJsonLd(artist),
    }),
  };
};

export const getProductJsonLd = (product, artist, currency = 'GBP') => {
  if (!currency) {
    currency = 'GBP';
  }

  const result = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    additionalType: 'Painting',
    image: product?.images?.[0]?.retina_url,
    name: product.name,
    brand: artist.name,
    description: product.category_full_name,
    sku: `${product.id}`,
    productID: `${product.id}`,
    url: product.full_url,

    manufacturer: getOrganizationJsonLd(artist),

    offers: getOffersJsonLd(product, currency),

    ...(product.review_count > 0 && {
      aggregateRating: getAggregateRatingJsonLd(artist),
    }),
  };

  return result;
};
